/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { Link } from '@atoms';
import { Form } from '@organisms';
import { COL_WITH_EXTRA } from '@constants';
import ROUTES from '@constants/routes';
import { useIsLOCadmin } from '@hooks';

import EventSelect from '../EventSelect';

const EventFormItem = React.forwardRef(
  (
    {
      initialEvent,
      wrapperCol,
      disabled,
      onChange,
      onSearch,
      showAction,
      placeholder,
      queryVariables,
      value,
      ...props
    },
    ref,
  ) => {
    const [selectedEvent, setSelectedEvent] = React.useState(initialEvent);
    const isLOCAdmin = useIsLOCadmin();

    const handleChange = (event) => {
      // eslint-disable-next-line no-unused-expressions
      onChange?.(event);
      setSelectedEvent(event);
    };

    return (
      <>
        <Form.WithFieldValue name={props.name}>
          {(_value) => {
            if (!_value) {
              setSelectedEvent(undefined);
            }
          }}
        </Form.WithFieldValue>
        <Form.ItemWithExtra
          wrapperCol={{ ...COL_WITH_EXTRA, ...wrapperCol }}
          extra={
            !!selectedEvent && (
              <Link
                to={isLOCAdmin ? ROUTES.EVENT_APPEARANCE : `/${ROUTES.EVENTS}/${selectedEvent.id}/appearance`}
                target="_blank"
                rel="noopener noreferrer"
              >
                Event setup
              </Link>
            )
          }
          {...props}
        >
          <EventSelect
            value={value}
            ref={ref}
            onChange={handleChange}
            disabled={disabled}
            onSearch={onSearch}
            showAction={showAction}
            placeholder={placeholder}
            queryVariables={queryVariables}
            {...props}
          />
        </Form.ItemWithExtra>
      </>
    );
  },
);

export default EventFormItem;
